import { HashRouter as Router, Route, Redirect, Switch } from 'react-router-dom'

import { PrivateRoute } from 'src/components/base/PrivateRoute';
import { ErrorPage } from 'src/components/base/ErrorPage';

import { Layout } from './components/layout/Layout';

import { Register } from './components/user/Register';
import { ActivateUser } from './components/user/ActivateUser';

import { Settings } from './components/settings';
import { ResetPassword } from './components/user/ResetPassword';
import { ChangePassword } from './components/user/ChangePassword';

import { Trap } from './components/trap';
import { TrapsMap } from './components/TrapsMap/TrapsMap';
import { Map } from './components/Map/Map';
import { Catches } from './components/catches/Catches';
import { Help } from './components/help';

import Groups from './components/groups';
import UsersContainer from 'src/components/users';
import { StoreProvider } from 'src/stores';

import 'assets/styles/app.scss';

export const App = () => {
  // const blackTheme = _.get(this.props, 'auth.email', '').endsWith('terminixuk.com');
  return (
    <StoreProvider>
        <Router>
          <Layout>
            <Switch>
              <PrivateRoute exact path="/" component={Groups} />
              <PrivateRoute path="/traps" component={Groups} />
              <PrivateRoute path="/groups" component={Groups} />
              <PrivateRoute path="/trap" component={Trap} />

              <PrivateRoute path="/users" component={UsersContainer} />
              {MINKS_BRAND === 'trapsensor'
                ? <PrivateRoute path="/map" component={Map} />
                : <PrivateRoute path="/map" component={TrapsMap} />}
              <Route path="/trap-map" render={() => <Redirect to="/map" />} />
              <PrivateRoute path="/catches" component={Catches} />
              <PrivateRoute path="/settings" component={Settings} />

              <Route path="/register" component={Register} />
              <Route path="/reset-password" component={ResetPassword} />
              <Route path="/activate-invitation" component={ChangePassword} />
              <Route path="/change-password" component={ChangePassword} />
              <Route path="/activate" component={ActivateUser} />
              <Route path="/activate-email" component={ActivateUser} />
              <Route path='/loginas' component={ActivateUser} />

              <PrivateRoute path='/help' component={Help} />
              <Route path="/404" render={() => <ErrorPage code={404} />} />
              <Redirect to="/404" />
            </Switch>
          </Layout>
        </Router>
    </StoreProvider>
  )
}